export default [
  'date',
  'downloadUrl',
  'name',
  'title',
  'themeId',
  'type',
];
